<!-- 加入我们 -->
<template>
  <div class="template-container">
    <div class="header-main">
      <div class="main-item">
        <router-link to="join-us" class="item-span item-active">{{
          $t("join_index.text1")
        }}</router-link>
      </div>
      <div class="main-item">
        <router-link to="social" class="item-span">{{
          $t("join_index.text2")
        }}</router-link>
      </div>
      <div class="main-item">
        <router-link to="campus" class="item-span">{{
          $t("join_index.text3")
        }}</router-link>
      </div>
    </div>
    <div class="container-main">
      <div class="main-top-box">
        <div class="img-top-back">
          <div class="back-text">
            为了邀你加入<br />我们每年飞行了上百万公里
          </div>
        </div>
        <img class="img-top" src="/static/images/about/join/join_top.png" />
      </div>
      <div>
        <div class="main-text1">加入我们 > 概览</div>
        <div class="main-title">“有梦想、有活力、有激情、勇于创新”</div>
        <div class="main-text3">
          航翊科技由一群“有梦想、有活力、有激情、勇于创新”的年轻人组成
        </div>
        <img class="img-list" src="/static/images/about/about/banner3.png" />
        <div class="main-title">“尊重、包容、发展”</div>
        <div class="main-text3">
          我们秉承“尊重、包容、发展”人才理念，努力为每一位加入我们的优秀人才提供施展才华的平台
        </div>
        <img class="img-bottom" src="/static/images/about/about/daqing.png" />
      </div>
      <div class="main-center-box">
        <div class="main-center-title">成为我们的一员</div>
        <div class="main-center-title" style="font-size: 16px;">我们一直在寻找“有梦想、有活力、有激情、勇于创新”的伙伴结伴同行，欢迎您的加入！</div>
        <div class="main-center-flex">
          <router-link class="main-center-text"  to="/social" style="margin-right: 91px;">
            社会招聘
            <img
              class="main-center-img"
              src="/static/images/about/about/jiantou13.png"
            />
          </router-link>
          <router-link class="main-center-text" to="/campus">
            校园招聘
            <img
              class="main-center-img"
              src="/static/images/about/about/jiantou13.png"
            />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang='stylus' scoped>
.template-container {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  overflow: hidden;
  box-sizing: border-box;
  background: #fff;

  .header-main {
    height: 66px;
    line-height: 66px;
    background: #244E84;
    display: flex;
    justify-content: center;

    .main-item {
      width: 160px;
      font-size: 18px;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;

      .item-span {
        padding: 10px;
        color: #fff;
      }

      .item-active {
        border-bottom: 2px solid #fff;
      }
    }
  }

  .container-main {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .main-top-box {
      width: 100%;
      max-width: 1920px;
      max-height: 454px;

      .img-top {
        object-fit: cover;
        width: 100%;
        max-width: 1920px;
        height: 454px;
        background: rgba(22, 80, 154, 0.8);
      }

      .img-top-back {
        z-index: 10;
        opacity: 1;
        position: absolute;
        width: 100%;
        max-width: 1920px;
        height: 454px;
        opacity: 0.9;
        text-align: center;
        font-size: 34px;
        font-weight: 500;
        color: #FFFFFF;
        background: linear-gradient(180deg, rgba(22, 80, 154, 0.3) 0%, rgba(100, 138, 188, 0.3) 99%);

        .back-text {
          margin-top: 154px;
          font-size: 34px;
          font-weight: 500;
          line-height: 46px;
          text-align: center;
          color: #FFFFFF;
        }
      }
    }

    .main-text1 {
      margin-top: 20px;
      margin-bottom: 56px;
      font-size: 12px;
      font-weight: 500;
      line-height: 29px;
      color: #3D3D3D;
    }

    .main-title {
      font-size: 24px;
      font-weight: 500;
      line-height: 52px;
      color: #1E5295;
      width: 1280px;
    }

    .main-text3 {
      max-width: 1280px;
      margin-top: 20px;
      margin-bottom: 41px;
      font-size: 16px;
      font-weight: 500;
      line-height: 26px;
      color: #666;
    }

    .img-list {
      width: 1280px;
      height: 537px;
      margin-bottom: 89px;
    }

    .img-bottom {
      object-fit: cover;
      width: 1280px;
      height: 600px;
    }

    .main-center-box {
      margin-top: 90px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 1920px;
      height: 220px;
      background: #1E5295;

      .main-center-title {
        font-size: 24px;
        font-weight: 500;
        line-height: 36px;
        text-align: center;
        color: #FFFFFF;
      }

      .main-center-flex {
        display: flex
        .main-center-text {
          margin-top: 20px;
         width: 235px;
          font-size: 16px;
          font-weight: 500;
          color: #FFFFFF;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 44px;
          background: #007BE7;

          .main-center-img {
            width: 40px;
            height: 40px;
          }
        }
      }
    }
  }
}

@media all and (min-width: 769px) and (max-width: 1400px) {
  // 0.4 ~ 0.75
  .template-container {
  }
}

// 移动端
@media all and (min-width: 320px) and (max-width: 768px) {
  .template-container {
    .template-content {
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/join/index.vue